import { render, staticRenderFns } from "./blockNpr.vue?vue&type=template&id=3efb0e80&scoped=true&"
import script from "./blockNpr.vue?vue&type=script&lang=js&"
export * from "./blockNpr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb0e80",
  null
  
)

export default component.exports